export const VENUE_PROFILES_RECORD_KEY = 'venue_profiles';
export const VENUE_PROFILE_FILES_RECORD_KEY = 'venue_profile_files';
